/* eslint-disable no-unused-vars */
import React, {Component} from 'react';

declare var ol;
const TILE_CACHE_SIZE = 350;

class MapPreview extends Component {
  constructor(props) {
    super(props);
    this.numCapas = 1;
    this.state = {
      map: null,
      coordinates: null,
    };
    this.frameToSee = props.hoja || 0;
    this.forceMount = props.forceMount || false;
  }

  onSetCoordinate(evt) {
    const {pluginListPreview, parentState} = this.props;
    //if (parentState.active > 5) { parentState.seleccionadoProductoSeries === 'Foto' || parentState.seleccionadoProductoSeries === 'Poster' 
    const auxName = parentState.seleccionadoProductoSeries === 'Elaborado' ? 'coordinates' : 'coordinatesPoster';
    if ((parentState[auxName] !== null || parentState[auxName] !== undefined) && parentState[auxName].length !== 0) {
      pluginListPreview[0].setCoordinates([parentState[auxName][this.frameToSee]], [parentState.inforFeatureCoordinates[this.frameToSee]], Number.parseFloat(parentState.selectedRow.substring(0,parentState.selectedRow.length-1))); // plugin Mapaalacarta
    }
  }

  componentWillUnmount(){
    if(this.resizeObserver)this.resizeObserver.disconnect();
    clearTimeout(this.timeoutResize);
  }

  componentDidMount() {
    const {
      M,
      centerX,
      centerY,
      parentState,
      pluginListPreview,
      isSimple,
      baseLayer,
      conversorPDF
    } = this.props;
    this.coordinates = null;
    this.stopGridGeneration = false;
    let aproxResolution, layerZoom;

    if(parentState.scale === "1:20.000"){
      aproxResolution = 18.4;//DEFAULT de 20k
      layerZoom = 15;
      this.gridFontSize = 91;
      this.scalingFactor = 20;
      this.extraRange = 1000;
    } else if (parentState.scale === "1:25.000") {
      aproxResolution = 23;//DEFAULT de 25k
      layerZoom = 15;
      this.gridFontSize = 110;
      this.scalingFactor = 25;
      this.extraRange = 1000;
    } else if(parentState.scale === "1:30.000") {
      aproxResolution = 27.5;//DEFAULT de 30k
      layerZoom = 15;
      this.gridFontSize = 140;
      this.scalingFactor = 30;
      this.extraRange = 1000;
    } else if(parentState.scale === "1:40.000") {
      aproxResolution = 36.9;//DEFAULT de 40k
      layerZoom = 14;
      this.gridFontSize = 190;
      this.scalingFactor = 40;
      this.extraRange = 2000;
    } else if (parentState.scale === "1:50.000") {
      aproxResolution = 46;//DEFAULT de 50k
      layerZoom = 14;
      this.gridFontSize = 230;
      this.scalingFactor = 50;
      this.extraRange = 2000;
    } else if (parentState.scale === "1:60.000") {
      aproxResolution = 55;//DEFAULT de 60k
      layerZoom = 14;
      this.gridFontSize = 270;
      this.scalingFactor = 60;
      this.extraRange = 2000;
    } else if (parentState.scale === "1:10.000") {
      aproxResolution = 10.3;//DEFAULT de 10k
      layerZoom = 15;
      this.gridFontSize = 45;
      this.scalingFactor = 10;
      this.extraRange = 1000;
    } else if (parentState.scale === "1:5.000") {
      aproxResolution = 5.2;//DEFAULT de 5k
      layerZoom = 15;
      this.gridFontSize = 25;
      this.scalingFactor = 5;
      this.extraRange = 500;
    } else if (parentState.scale === "1:2.500") {
      aproxResolution = 2.6;//DEFAULT de 2.5k
      layerZoom = 15;
      this.gridFontSize = 12;
      this.scalingFactor = 2.5;
      this.extraRange = 300;
    }
    if(parentState.orientation === 'Retrato'){//para reducir un poco el tamaño de los textos de grid en este caso.
      this.gridFontSize = this.gridFontSize - Math.ceil(this.gridFontSize*0.1);
    }
    //let mapBaseLayer = baseLayer === 'PNOA' ? 'TMS*Orto*https://tms-pnoa-ma.idee.es/1.0.0/pnoa-ma/{z}/{x}/{-y}.jpeg*false*false' : 'TMS*MTN*https://tms-mapa-raster.ign.es/1.0.0/mapa-raster/{z}/{x}/{-y}.jpeg*false*false';
    let mapBaseLayer = baseLayer === 'PNOA' ? 'TMS*Orto*https://tms-pnoa-ma.idee.es/1.0.0/pnoa-ma/{z}/{x}/{-y}.jpeg*true*false' : 'TMS*MTN*https://tms-mapa-raster.ign.es/1.0.0/mapa-raster/{z}/{x}/{-y}.jpeg*true*false';
    if (window.mapJsPrev) {
      window.mapJsPrev.destroy();
    }

    const numberOfResponsiveZooms = 500, startingRange = 300;
    const endRange = startingRange - numberOfResponsiveZooms;
    const fraction = Math.floor((aproxResolution/Math.abs(endRange))*10000)/10000;
    let AllZoomLevels = new Array(numberOfResponsiveZooms);
    for(let j = 0, i = startingRange; i >= endRange; j++,i--){//GENERATE RESPONSIVITY ZOOM LEVELS.
      AllZoomLevels[j] = Number.parseFloat((aproxResolution+(i*fraction)).toFixed(3));
    }// aproxResolution+(endRange*fraction) SHOULD NEVER BE NEGATIVE

    const zoom = 330;
    window.mapJsPrev = M.map({
      container: 'map',
      layers: [mapBaseLayer],
      projection: "EPSG:3857*m",
      controls: [""],
      center: {
        x: centerX,
        y: centerY
      },
      resolutions:AllZoomLevels,//specified resolution at zoom 15
      zoom: zoom,// always defaults to 28 at start
    });
    window.mapJsPrev.setZoom(zoom);//forced initial zoom to avoid default 28
    window.mapJsPrev.getMapImpl().maxTilesLoading_=TILE_CACHE_SIZE; //256 no es suficiente para 60k o 30k
    const firstLayerSource = window.mapJsPrev.getLayers()[0].getImpl().getOL3Layer().getSource();
    firstLayerSource.getTileGrid().minZoom = layerZoom;
    firstLayerSource.tileOptions.transition = 1000;
    let featuresFromEditMap = [];parentState.mapa.getLayers().filter(l=>(l.legend && l.legend.endsWith('(Líneas)')) || l.impl_.name === '__draw__' || l.from_parameters || l.layerAddedByEditionTools).forEach(l=>l.getFeatures().forEach(f=>{//Añadir todos features del mapa de editado clonados.
      let auxF = new M.Feature(f.id, f.getGeoJSON());let auxS = f.getImpl().getOLFeature().getStyle();
      //if(auxS){//If not, maybe InsertPhoto Plugin }
      if (f.getImpl().getOLFeature().realStyle) {
        auxF.getImpl().getOLFeature().realStyle = f.getImpl().getOLFeature().realStyle;
      }
      if(auxS instanceof Array){let auxA = [];
        auxS.forEach(s=>auxA.push(s.clone()));auxF.getImpl().getOLFeature().setStyle(auxA);
        if(auxF.impl_.olFeature_.style_[0].stroke_.lineDash_){
          auxF.impl_.olFeature_.style_[0].stroke_.lineDash_.forEach((d,i)=>!d===1 && (auxF.impl_.olFeature_.style_[0].stroke_.lineDash_[i]=d/2));//Estilo de lineas arreglado
        }
      }else{
        auxF.getImpl().getOLFeature().setStyle(auxS.clone());
        if(auxF.impl_.olFeature_.style_.stroke_ && auxF.impl_.olFeature_.style_.stroke_.lineDash_){
          auxF.impl_.olFeature_.style_.stroke_.lineDash_.forEach((d,i)=>!d===1 && (auxF.impl_.olFeature_.style_[0].stroke_.lineDash_[i]=d/2));//Estilo de polígonos arreglado
        }
      }
      featuresFromEditMap.push(auxF);
    }));
    featuresFromEditMap.forEach((f,i)=>{f.impl_.olFeature_.id_ =f.impl_.olFeature_.id_+i;});//Los layers se reparten en elementos con Similares ID, por lo que se asegura que son únicos.
    window.mapJsPrev.getLayers().find(l=>l.impl_.name === '__draw__').addFeatures(featuresFromEditMap);

    if(parentState.mapa.getLayers().find(l=>l.impl_.name === 'insertPhoto')){//Plugin insertPhoto
      parentState.mapa.getMapImpl().getLayers().array_.filter(l => l.values_.id && l.values_.id.startsWith("photo-")).forEach(lp =>{
        window.mapJsPrev.getMapImpl().removeLayer(window.mapJsPrev.getMapImpl().getLayers().array_.find(lpp => lpp.values_.id===lp.values_.id));
        const imageLayer = new ol.layer.Image();
        imageLayer.set('id', lp.values_.id);
        window.mapJsPrev.getMapImpl().addLayer(imageLayer);
        imageLayer.set('vendor.mapaalacarta.imageLayer', true);
        imageLayer.setSource(lp.getSource());
      });
    }

    let findgrid1 = conversorPDF.attributes.mapDef1.layers.find(l => l.type === 'grid');
    let findgrid2 = conversorPDF.attributes.mapDef2.layers.find(l => l.type === 'grid');

    let BBOXOriginal = {x:{min: Infinity , max: -Infinity},y:{ min: Infinity , max: -Infinity}};//BBOXOriginal = window.mapJsPrev.getBbox();
    //parentState.seleccionadoProductoSeries === 'Foto' || parentState.seleccionadoProductoSeries === 'Poster'
    const auxName = parentState.seleccionadoProductoSeries === 'Elaborado' ? 'coordinates' : 'coordinatesPoster';
    parentState[auxName][this.frameToSee][0].forEach((c) => {
      if (c[0] < BBOXOriginal.x.min) { BBOXOriginal.x.min = c[0]; }
      if (c[1] < BBOXOriginal.y.min) { BBOXOriginal.y.min = c[1]; }
      if (c[0] > BBOXOriginal.x.max) { BBOXOriginal.x.max = c[0]; }
      if (c[1] > BBOXOriginal.y.max) { BBOXOriginal.y.max = c[1]; }
    });

    if(findgrid1 || findgrid2){

      const spacing = findgrid1?findgrid1.spacing[0]:findgrid2.spacing[0]===0?findgrid2.spacing[1]:findgrid2.spacing[0];
      this.currentHUSO = 'EPSG:258' + parentState.centroidSheet[this.frameToSee].getAttribute('HUSO');

      const minimos = ol.proj.transform([BBOXOriginal.x.min, BBOXOriginal.y.min], 'EPSG:3857', this.currentHUSO );const maximos = ol.proj.transform([BBOXOriginal.x.max, BBOXOriginal.y.max], 'EPSG:3857', this.currentHUSO );
      const BBOXajustado = {x:{min: 0 , max: 0},y:{ min: 0 , max: 0}};
      if(maximos[0]>minimos[0]){
        BBOXajustado.x.max = Math.ceil(maximos[0]/spacing)*spacing;
        BBOXajustado.x.min = Math.floor(minimos[0]/spacing)*spacing;
      }else{
        BBOXajustado.x.max = Math.ceil(minimos[0]/spacing)*spacing;
        BBOXajustado.x.min = Math.floor(maximos[0]/spacing)*spacing;
      }

      if(maximos[1]>minimos[1]){
        BBOXajustado.y.max = Math.ceil(maximos[1]/spacing)*spacing;
        BBOXajustado.y.min = Math.floor(minimos[1]/spacing)*spacing;
      }else{
        BBOXajustado.y.max = Math.ceil(minimos[1]/spacing)*spacing;
        BBOXajustado.y.min = Math.floor(maximos[1]/spacing)*spacing;
      }

      this.coordDisigned2 = [];this.coordDisigned3 = [];
      for(let j = BBOXajustado.y.min,k=0; j<=BBOXajustado.y.max;j = j+spacing,k++){
        if(k%2 === 0){this.coordDisigned2.push(ol.proj.transform([BBOXajustado.x.min,j], this.currentHUSO, 'EPSG:3857'),ol.proj.transform([BBOXajustado.x.max,j], this.currentHUSO, 'EPSG:3857'))
        }else{this.coordDisigned2.push(ol.proj.transform([BBOXajustado.x.max,j], this.currentHUSO, 'EPSG:3857'),ol.proj.transform([BBOXajustado.x.min,j], this.currentHUSO, 'EPSG:3857'))}
      }
      const yStart = this.coordDisigned2[this.coordDisigned2.length-1][1]===BBOXajustado.y.min ? BBOXajustado.y.min : BBOXajustado.y.max;
      const yEnd = this.coordDisigned2[this.coordDisigned2.length-1][1]===BBOXajustado.y.min ? BBOXajustado.y.max : BBOXajustado.y.min;
      if(this.coordDisigned2[this.coordDisigned2.length-1][0]===BBOXajustado.x.min){
        for(let i = BBOXajustado.x.min,z=0; i<=BBOXajustado.x.max;i=i+spacing,z++){
          if(z%2 === 0){this.coordDisigned3.push(ol.proj.transform([i,yStart], this.currentHUSO, 'EPSG:3857'),ol.proj.transform([i,yEnd], this.currentHUSO, 'EPSG:3857'))
          }else{this.coordDisigned3.push(ol.proj.transform([i,yEnd], this.currentHUSO, 'EPSG:3857'),ol.proj.transform([i,yStart], this.currentHUSO, 'EPSG:3857'))}
        }
      }else{
        for(let i = BBOXajustado.x.max,z=0; i>=BBOXajustado.x.min;i=i-spacing,z++){
          if(z%2 === 0){this.coordDisigned3.push(ol.proj.transform([i,yStart], this.currentHUSO, 'EPSG:3857'),ol.proj.transform([i,yEnd], this.currentHUSO, 'EPSG:3857'))
          }else{this.coordDisigned3.push(ol.proj.transform([i,yEnd], this.currentHUSO, 'EPSG:3857'),ol.proj.transform([i,yStart], this.currentHUSO, 'EPSG:3857'))}
        }
      }
      this.memorizeRotation = Math.PI*2+Math.atan((this.coordDisigned2[0][1]-this.coordDisigned2[1][1])/(this.coordDisigned2[0][0]-this.coordDisigned2[1][0])); //Math.PI*2 necesario para dar 1 vuelta entera ya que los valores menores no aplican la rotación
      window.mapJsPrev.removeLayers(window.mapJsPrev.getLayers().find(l=>l.impl_.name === 'GRIDCustomOl'));
      if(findgrid1){// MAKES GRID not rotated
        window.mapJsPrev.getMapImpl().getView().setRotation(this.memorizeRotation);
        const coordDisigned = this.coordDisigned2.concat(this.coordDisigned3);
        window.mapJsPrev.addLayers(new M.layer.GeoJSON({
          name: "GRIDCustomOl",
          source: {
            type: "FeatureCollection",
            features: [
              {
                type: 'Feature',
                geometry: {type: "LineString", coordinates: coordDisigned}
              }
            ],
            crs: {properties: {name: "EPSG:3857"},type: "name"},
          }
        }));
        window.mapJsPrev.getLayers().find(l=>l.impl_.name === 'GRIDCustomOl').setStyle(new M.style.Line({
          fill: {color: findgrid1.gridColor,width: 1}
        }))
      }

      if(findgrid2){
        if (window.secondGridMap) {
          window.secondGridMap.removeLayers(window.secondGridMap.getLayers().find(l=>l.impl_.name === 'GRIDCustomOl2'));
          window.secondGridMap.destroy();
        }
        this.styleGrid2 ={labelColor:findgrid2.labelColor, strokeColor:findgrid2.style["*"].symbolizers[0].strokeColor, strokeWidth:findgrid2.style["*"].symbolizers[0].strokeWidth};
        let layer2 = new M.layer.Vector({name: "GRIDCustomOl2"});//layer2.addFeatures(line2Feature);
        this.secondGridMap = M.map({
          container: 'map2',
          layers: [layer2],
          projection: "EPSG:3857*m",
          controls: [""],
          center: {x: centerX,y: centerY},
          resolutions:AllZoomLevels,
          zoom: zoom
        });
        window.secondGridMap = this.secondGridMap;
        if (window.thirdGridMap) {
          window.thirdGridMap.removeLayers(window.thirdGridMap.getLayers().find(l=>l.impl_.name === 'GRIDCustomOl3'));
          window.thirdGridMap.destroy();
        }
        let layer3 = new M.layer.Vector({name: "GRIDCustomOl3"});//layer3.addFeatures(line3Feature);
        this.thirdGridMap = M.map({
          container: 'map3',
          layers: [layer3],
          projection: "EPSG:3857*m",
          controls: [""],
          center: {x: centerX,y: centerY},
          resolutions:AllZoomLevels,
          zoom: zoom
        });
        window.thirdGridMap = this.thirdGridMap;
      }
    } else {
      //No present Grids, but still needs this.memorizeRotation
      const spacing = 1000;
      this.currentHUSO = 'EPSG:258' + parentState.centroidSheet[this.frameToSee].getAttribute('HUSO');
      const minimos = ol.proj.transform([BBOXOriginal.x.min, BBOXOriginal.y.min], 'EPSG:3857', this.currentHUSO );const maximos = ol.proj.transform([BBOXOriginal.x.max, BBOXOriginal.y.max], 'EPSG:3857', this.currentHUSO );
      let ymin,xmin,xmax;
      if(maximos[0]>minimos[0]){
        xmax = Math.ceil(maximos[0]/spacing)*spacing;
        xmin = Math.floor(minimos[0]/spacing)*spacing;
      }else{
        xmax = Math.ceil(minimos[0]/spacing)*spacing;
        xmin = Math.floor(maximos[0]/spacing)*spacing;
      }
      if(maximos[1]>minimos[1]){
        ymin = Math.floor(minimos[1]/spacing)*spacing;
      }else{
        ymin = Math.floor(maximos[1]/spacing)*spacing;
      }
      const inicioPrueba = ol.proj.transform([xmin,ymin], this.currentHUSO, 'EPSG:3857');
      const finalPrueba = ol.proj.transform([xmax,ymin], this.currentHUSO, 'EPSG:3857');
      this.memorizeRotation = Math.PI*2+Math.atan((inicioPrueba[1]-finalPrueba[1])/(inicioPrueba[0]-finalPrueba[0])); //Math.PI*2 necesario para dar 1 vuelta entera ya que los valores menores no aplican la rotación
    }

    if (isSimple) {
      pluginListPreview[0].posterMode_ = true;
    }

    window.mapJsPrev.addPlugin(pluginListPreview[0]);
    setTimeout(() => {
      this.onSetCoordinate();
      this.removeInteractions(window.mapJsPrev);
      if(this.secondGridMap){
        this.removeInteractions(this.secondGridMap);
        this.removeInteractions(this.thirdGridMap);
      }
      const pluginFrame = pluginListPreview[0].getCoordinates();
      let auxExtent = [Infinity, Infinity, -Infinity, -Infinity];
      pluginFrame[1].forEach((c) => {
        if (c[0] < auxExtent[0]) { auxExtent[0] = c[0]; }
        if (c[1] < auxExtent[1]) { auxExtent[1] = c[1]; }
        if (c[0] > auxExtent[2]) { auxExtent[2] = c[0]; }
        if (c[1] > auxExtent[3]) { auxExtent[3] = c[1]; }
      });
      const frameExtent = auxExtent;
      const pluginExtent = [auxExtent[0]-this.extraRange, auxExtent[1]-this.extraRange, auxExtent[2]+this.extraRange, auxExtent[3]+this.extraRange]
      window.mapJsPrev.setMaxExtent(pluginExtent);
      window.mapJsPrev.getLayers()[0].getImpl().getOL3Layer().setExtent(pluginExtent);
      firstLayerSource.tileCache.highWaterMark=TILE_CACHE_SIZE;
      pluginListPreview[0].clearStyles();
      this.resizeObserver = new ResizeObserver(()=>{
        clearTimeout(this.timeoutResize);
        this.timeoutResize = setTimeout( ()=>{
          if(this.memorizeRotation){
            window.mapJsPrev.getMapImpl().getView().setRotation(0);
          }
          window.mapJsPrev.getMapImpl().getView().fit(frameExtent,{size:window.mapJsPrev.getMapImpl().getSize()});
          //window.mapJsPrev.getLayers()[0].setVisible(true);//made to apear only now after fit
          if(this.memorizeRotation){
            window.mapJsPrev.getMapImpl().getView().setRotation(this.memorizeRotation);
          }
          this.scaleAllFeaturesToRealPDF();
          if(this.secondGridMap){
            this.secondGridMap.setZoom(window.mapJsPrev.getZoom());
            this.thirdGridMap.setZoom(window.mapJsPrev.getZoom());
            if(!this.stopGridGeneration){this.configurarValoresGrid();}
          }
        }, 500 );
      });
      this.resizeObserver.observe(document.getElementsByClassName("NewPDFPreviewClass")[0]);
    }, 400);
    /*if(window.navigator && window.navigator.userAgent && window.navigator.userAgent.includes('Chrome/')) setTimeout(()=>{
      firstLayerSource.refresh(); //Chrome transparent tiles fix
    },1100);*/
  }

  scaleAllFeaturesToRealPDF(){
    const currentResolution = window.mapJsPrev.getMapImpl().getView().getResolution();
    const auxDivision = Number.parseFloat((this.scalingFactor/currentResolution).toFixed(2));
    window.mapJsPrev.getLayers().filter(l => (l.legend && l.legend.endsWith('(Líneas)')) || l.name === '__draw__').forEach(l => {
      l.getFeatures().forEach(f => {
        let feature = f.getImpl().getOLFeature()
        let style = feature.getStyle();
        if(style instanceof Array){//lines
          style[0].getStroke().setWidth(feature.realStyle.stroke_width*auxDivision*0.8); // 0.8 reduce width igual que en PDF;
          if(feature.realStyle.dash) {
            style[0].getStroke().setLineDash(feature.realStyle.dash.sizes.map((d) => {
              if (d === 1) { return 0; }
              return (d * auxDivision) / 3.69; // 3.69 para aumentar dash igual que en PDF
            }));
          }
          if(style[1]){
            style[1].image_.radius_ = feature.realStyle.stroke_width*auxDivision*2;
            style[1].image_.render();
          }
        }else{
          if(style.image_){//Image
            if (feature.realStyle.scale) {
              style.image_.setScale(auxDivision * 0.9); // 0.9 reduce scale igual que en PDF
            } else {
              style.image_.setRadius(feature.realStyle.image.radius*auxDivision);
              style.image_.stroke_.setWidth(0);style.image_.stroke_.setColor('#00000000')//feature.realStyle.image.stroke_width*auxDivision
              style.image_.render();
            }
          }else{
            if(style.getStroke()){//Polygon
              style.getStroke().setWidth(feature.realStyle.stroke_width*auxDivision*0.8); // 0.8 reduce width igual que en PDF
              if(feature.realStyle.dash) {
                style.getStroke().setLineDash(feature.realStyle.dash.sizes.map((d) => {
                  if (d === 1) { return 0; }
                  return (d * auxDivision) / 3.69; // 3.69 para aumentar dash igual que en PDF
                }));
              }
            }else{
              if(style.text_){//Text
                if(!style.fontOriginal){
                  style.fontOriginal = style.text_.getFont();
                }
                style.text_.setScale(0.7);
                // style.text_.setFont(style.fontOriginal.replace(/\d+(\.\d+)?/,(num)=>{return (Number.parseInt(num)*auxDivision * 0.9).toFixed(2)})); // textRatio(0.7) of DPI 300 made 0.9
              }
            }
          }
        }
      });
    });
  }

  configurarValoresGrid(){
    const {M} = this.props;
    let bboxMap = window.mapJsPrev.getBbox();
    let bboxGridH = this.secondGridMap.getBbox();
    let middleLeft = (bboxGridH.x.min+bboxMap.x.min)/2;
    let middleRight = (bboxMap.x.max+bboxGridH.x.max)/2;
    let customStyleFeature = (feature, resolution)=>{ //OPENLAYERS
      let fontSize = (this.gridFontSize/resolution).toFixed(2) + 'px Swz721';//34(5k) as default font size.
      return new ol.style.Style({
        image: new ol.style.Circle({radius: 0}),
        text: new ol.style.Text({
          textAlign: "center",//align == '' ? undefined : align,
          textBaseline: "middle",//baseline,
          font: fontSize,//'9px Swz721',//font,
          text: feature.values_.nombre+'',//getText(feature, resolution, dom),
          fill: new ol.style.Fill({color: this.styleGrid2.labelColor}),
          stroke: new ol.style.Stroke({color: this.styleGrid2.strokeColor, width: this.styleGrid2.strokeWidth}),
          offsetX: 0,//offsetX,
          offsetY: 0,//offsetY,
          //placement: 'Point',//placement,
          //maxAngle: 45,//maxAngle,
          //overflow: true,//overflow,
          rotation: 0,//rotation,
        }),
      });
    };
    for(let i=0;i<this.coordDisigned2.length;i=i+2){
      if(bboxGridH.y.min< this.coordDisigned2[i][1] && this.coordDisigned2[i][1]<bboxGridH.y.max){
        let textH = ol.proj.transform(this.coordDisigned2[i], 'EPSG:3857', this.currentHUSO )[1].toFixed();//this.coordDisigned2[i][1];
        let auxMiddle =(this.coordDisigned2[i][1] + this.coordDisigned2[i+1][1])/2;
        let intersectLeft = [middleLeft,auxMiddle];
        let intersectRight = [middleRight,auxMiddle];
        let f1 = "HorizontalMinText"+i;
        let leftF = new M.Feature(f1, {
          "type": "Feature","id": f1,
          "geometry": {"type": "Point","coordinates": intersectLeft},
          "properties": {"nombre": textH}
        });
        let f2 = "HorizontalMaxText"+i;
        let rightF = new M.Feature(f2, {
          "type": "Feature","id": f2,
          "geometry": {"type": "Point","coordinates": intersectRight},
          "properties": {"nombre": textH}
        });
        leftF.getImpl().olFeature_.styleFunction_ = customStyleFeature.bind(this);
        rightF.getImpl().olFeature_.styleFunction_ = customStyleFeature.bind(this);
        let layerH = this.secondGridMap.getLayers().find(l=>l.impl_.name === 'GRIDCustomOl2');
        layerH.addFeatures([leftF,rightF]);
      }
    }

    let bboxGridV = this.thirdGridMap.getBbox();
    let middleTop = (bboxGridV.y.max+bboxMap.y.max)/2;
    let middleBottom = (bboxMap.y.min+bboxGridV.y.min)/2;
    for(let j=0;j<this.coordDisigned3.length;j=j+2){
      if(bboxGridV.x.min<this.coordDisigned3[j][0] && this.coordDisigned3[j][0]<bboxGridV.x.max){
        let textV = ol.proj.transform(this.coordDisigned3[j], 'EPSG:3857', this.currentHUSO )[0].toFixed();//this.coordDisigned3[j][0];
        let auxMiddle =(this.coordDisigned3[j][0] + this.coordDisigned3[j+1][0])/2;
        let intersectTop = [auxMiddle,middleTop];
        let intersectBottom = [auxMiddle,middleBottom];
        let f3 = "VerticalMaxText"+j;
        let topF = new M.Feature(f3, {
          "type": "Feature","id": f3,
          "geometry": {"type": "Point","coordinates": intersectTop},
          "properties": {"nombre": textV}
        });
        let f4 = "VerticalMinText"+j;
        let bottomF = new M.Feature(f4, {
          "type": "Feature","id": f4,
          "geometry": {"type": "Point","coordinates": intersectBottom},
          "properties": {"nombre": textV}
        });
        topF.getImpl().olFeature_.styleFunction_ = customStyleFeature.bind(this);
        bottomF.getImpl().olFeature_.styleFunction_ = customStyleFeature.bind(this);
        let layerV = this.thirdGridMap.getLayers().find(l=>l.impl_.name === 'GRIDCustomOl3');
        layerV.addFeatures([topF,bottomF]);
      }
    }
    this.stopGridGeneration = true;//POSIBLEMENTE SERíA MEJOR AÑADIR CÓDIGO QUE PONE LOS FEATURES CORRECTAMENTE AL HACER EL RESIZE
  }

  removeInteractions(mapWithInter) {
    const sizeArrayOriginal = mapWithInter.getMapImpl().getInteractions().getArray().length;
    for (let i = sizeArrayOriginal; i > 0; i--) {
      mapWithInter.getMapImpl().removeInteraction(mapWithInter.getMapImpl().getInteractions().getArray()[i]);
    }
  }

  render() {
    const {parentState} = this.props;
    let aspectRatioClass;
    if(parentState.orientation === 'Paisaje'){
      if(parentState.posterLegend){
        if(parentState.scale === "1:40.000" || parentState.scale === "1:50.000"|| parentState.scale === "1:60.000"){
          aspectRatioClass = 'aspectRatioPoster_L_HIGH';
        } else {
          aspectRatioClass = 'aspectRatioPoster_L';
        }
      } else {
        if(parentState.verticalCartela){
          aspectRatioClass = 'aspectRatioLandscape_R';
        } else {
          if(parentState.seleccionadoProductoSeries === 'Elaborado'){//if(parentState.active< 6){
            aspectRatioClass = 'aspectRatioLandscape';
          }else{
            aspectRatioClass = 'aspectRatioPoster';
          }
        }
      }
    } else {
      if(parentState.posterLegend){
        aspectRatioClass = 'aspectRatioPosterPortrait_L';
      } else {
        if(parentState.verticalCartela){
          aspectRatioClass = 'aspectRatioPortrait_R';
        } else {
          if(parentState.seleccionadoProductoSeries === 'Elaborado'){//if(parentState.active< 6){
            aspectRatioClass = 'aspectRatioPortrait';
          }else{
            aspectRatioClass = 'aspectRatioPosterPortrait';
          }
        }
      }
    }

    this.forceMount = this.props.forceMount || false;
    if(this.forceMount && this.frameToSee !== this.props.hoja){
      this.frameToSee = this.props.hoja || 0;
      this.componentWillUnmount();
      this.componentDidMount();
    }

    return (
      <div id="map" className={"map-preview "+aspectRatioClass + (parentState.backgroundMar ==="#FFFFFF"?"":" backgroundMar")}>{}</div>
    );
  }
}

export default MapPreview;
